module.exports = __webpack_public_path__ + "img/credit-card.ed29737e.svg";